import { render, staticRenderFns } from "./HotelsList.vue?vue&type=template&id=0304fd08&scoped=true&"
import script from "./HotelsList.vue?vue&type=script&lang=js&"
export * from "./HotelsList.vue?vue&type=script&lang=js&"
import style0 from "./HotelsList.vue?vue&type=style&index=0&id=0304fd08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304fd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
